import { brandSpecificStaticText } from 'utils/staticText';
import { CONTENT_MHG_STATIC } from './mhg';
import money101 from './money101';
import moneyhero from './moneyhero';
import moneymax from './moneymax';

export const TRANSLATIONS = brandSpecificStaticText({
  _: CONTENT_MHG_STATIC,
  moneyhero,
  money101,
  moneymax,
});
